// --------------------------------------------------------------
// Created On: 2025-11-04
// Author: Zachary Thomas
//
// Last Modified: 2025-11-04
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
let initialState = false;
const localStorageValue = localStorage.getItem("reduxMfaChallengeRequired");
if (localStorageValue === "true") {
  initialState = true;
}

// A Redux slice for the mobile app to be able to communicate that an MFA challenge is required.
const mobileMfaChallengeRequiredSlice = createSlice({
  name: "mobileMfaChallengeRequired",
  initialState,
  reducers: {
    setMobileMfaChallengeRequired: (state, action: PayloadAction<boolean>) => {
      if (action.payload === true) {
        localStorage.setItem("reduxMfaChallengeRequired", "true");
      } else {
        localStorage.setItem("reduxMfaChallengeRequired", "false");
      }
      return action.payload;
    },
  },
});

export const { setMobileMfaChallengeRequired } = mobileMfaChallengeRequiredSlice.actions;
export default mobileMfaChallengeRequiredSlice.reducer;
